import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Link } from 'react-router-dom';

import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import possibilityImage from '../../assets/place3.jpeg';
import slider1 from '../../assets/place1.jpg';
import slider2 from '../../assets/place4.jpeg';

const PlaceList = () => (
  <div className="container">
    <div className="row">
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <Link to="/details">
          <button type="submit" className="btn btn-success col-xl">Details place1 </button>
        </Link>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <Link to="/details">
          <button type="submit" className="btn btn-success col-xl">Details place1 </button>
        </Link>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <Link to="/details">
          <button type="submit" className="btn btn-success col-xl">Details place1 </button>
        </Link>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <Link to="/details">
          <button type="submit" className="btn btn-success col-xl">Details place1 </button>
        </Link>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <Link to="/details">
          <button type="submit" className="btn btn-success col-xl">Details place1 </button>
        </Link>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <Link to="/details">
          <button type="submit" className="btn btn-success col-xl">Details place1 </button>
        </Link>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <Link to="/details">
          <button type="submit" className="btn btn-success col-xl">Details place1 </button>
        </Link>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <button type="submit" className="btn btn-success col-xl">Details place </button>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <button type="submit" className="btn btn-success col-xl">Details place </button>
      </div>
      <div className="col-md-4">
        <Carousel width="100%" autoPlay infiniteLoop showThumbs={false} showIndicators={false} showStatus={false}>
          <div>
            <img src={possibilityImage} />
          </div>
          <div>
            <img src={slider1} />
          </div>
          <div>
            <img src={slider2} />
          </div>
        </Carousel>
        <button type="submit" className="btn btn-success col-xl">Details place </button>
      </div>
    </div>
  </div>
);

export default PlaceList;
